import React from 'react';
import './Contact.css';

function Contact() {
  const whatsappNumber = '918368305178';
  const instaHandle = 'theroyalutsav';

  return (
    <section className="contact" id="contact">
      <h2>Contact Us</h2>
      <p>Want to order? DM us directly on WhatsApp or Instagram!</p>

      <div className="contact-links">
        <a
          href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to order PPS products`}
          target="_blank"
          rel="noopener noreferrer"
          className="contact-btn whatsapp"
        >
          WhatsApp Us
        </a>

        <a
          href={`https://instagram.com/${instaHandle}`}
          target="_blank"
          rel="noopener noreferrer"
          className="contact-btn insta"
        >
          DM on Instagram
        </a>
      </div>
    </section>
  );
}

export default Contact;